import { GridViewMetadata } from '../../../grid/gridView/types';
import { Filter } from '../../../grid/gridFilters/types';

export enum Column {
  RULE_NAME = 0,
  RECOMMENDATIONS = 1,
  RULE_TRIGGER_DATE = 2,
  TARGETED_ACTIVITY_TYPE = 3,
  RULE_TRIGGERS = 4,
  BEHAVIORAL_PROFILES = 5,
  RESTRICTED_BEHAVIORAL_PROFILES = 6,
  COMPANY = 7,
  ROW_ACTIONS = 8,
  BEHAVIORAL_PROFILE_IDENTITIES = 9,
  BEHAVIORAL_PROFILE_RESOURCES = 10,
}

export enum ColumnKeys {
  RULE_NAME = 'ruleId',
  RECOMMENDATIONS = 'recommendations',
  RULE_TRIGGER_DATE = 'ruleTriggerDate',
  TARGETED_ACTIVITY_TYPE = 'targetedActivityType',
  RULE_TRIGGERS = 'ruleTriggers',
  BEHAVIORAL_PROFILES = 'behavioralProfiles',
  RESTRICTED_BEHAVIORAL_PROFILES = 'restrictedBehavioralProfiles',
  ROW_ACTIONS = 'rowActions',
  COMPANY = 'company',
  BEHAVIORAL_PROFILE_IDENTITIES = 'behavioralProfileIdentities',
  BEHAVIORAL_PROFILE_RESOURCES = 'behavioralProfileResources',
}

export interface PhasrMonitoredRulesWebComponentSchema {
  viewMetaData: GridViewMetadata<Column, ColumnKeys>;
  defaultViewProps: DefaultViewProps;
}

export interface DefaultViewProps {
  displayedColumns: Array<Column>;
  filters: Array<Filter<ColumnKeys>>;
  pageSize: number;
  compactView: boolean;
}

export enum PhasrMonitoredRulesMethod {
  READ_RECORDS = 'getMonitoredRules',
  UPDATE_BEHAVIOUR_ACTIONS = 'updateRulesBehaviourActions'
}

export enum ErrorCodes {
  COMPANY_DOES_NOT_EXIST_OR_IS_NOT_ACCESSIBLE = 3111,
}

export interface PhasrDictionaryEntry {
  category: string;
  rule_description: string;
  rule_recommendation: string;
  rule_name: string;
  ruleId: string;
}

export enum PhasrMonitoredRulesGridEvents {
  OnEditAccessFromGrid = 'onEditAccessFromGrid',
  OnEditAccessFromDetailsPanel = 'onEditAccessFromDetailsPanel',
  OnEditAccessFromSidePanel = 'onEditAccessFromSidePanel',
}

export interface AvailableCompany {
  name: string;
  _id: string;
}

export interface AvailableCompaniesResponse {
  data: Array<AvailableCompany>;
}

export interface GridEntry {
  objectId: string;
  ruleId: number;
  recommendations: number;
  ruleTriggerDate: number;
  ruleTriggers: number;
  behavioralProfiles: number;
  restrictedBehavioralProfiles: number;
  companyId: string;
  companyName: string;
  phasrUsable: boolean;
}

export interface GridEntryItem {
  item: GridEntry;
  index: number;
}

export interface GetMonitoredRulesResponse {
  data: GridEntry[];
  total: number;
}

export interface GetRowsResponse {
  success: boolean;
  rawEvents: GridEntry[];
}
